import React from "react";
import Table from "react-bootstrap/Table";
import DemographicAdditionalContent from "../DemographicAdditionalContent";

const DDMSExample = () => {
  return (
    <>
      <h4 className="font-weight-bold mb-2">Example Format</h4>
      <div className="overflow-auto mb-3">
        <Table className="uploadExampleTable table-mb">
          <thead>
            <tr>
              <th>District_Name</th>
              <th>Last</th>
              <th>First</th>
              <th>Student_ID</th>
              <th>Race</th>
              <th>Gender</th>
              <th>Free or Reduced Lunch <DemographicAdditionalContent assessmentType="DDMS" field="lunch"/></th>
              <th>Special Education <DemographicAdditionalContent assessmentType="DDMS" field="specialEducation"/></th>
              <th>ELL <DemographicAdditionalContent assessmentType="DDMS" field="ell"/></th>
              <th>SLD <DemographicAdditionalContent assessmentType="DDMS" field="sld"/></th>
              <th>Additional_Codes</th>
              <th>DIBELS_Approved_Accommodations</th>
              <th>Year_K</th>
              <th>School_K</th>
              <th>Class_K</th>
              <th>Teacher_K</th>
              <th>LNF_K_Middle</th>
              <th>Benchmark_Status_LNF_K_Middle</th>
              <th>PSF_K_Middle</th>
              <th>Benchmark_Status_PSF_K_Middle</th>
              <th>NWF-CLS_K_Middle</th>
              <th>Benchmark_Status_NWF-CLS_K_Middle</th>
              <th>NWF-WRC_K_Middle</th>
              <th>Benchmark_Status_NWF-WRC_K_Middle</th>
              <th>WRF_K_Middle</th>
              <th>Benchmark_Status_WRF_K_Middle</th>
              <th>Composite_K_Middle</th>
              <th>Benchmark_Status_Composite_K_Middle</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Sample District</td>
              <td>Doe</td>
              <td>John</td>
              <td>1111</td>
              <td>Asian/White</td>
              <td>Male <DemographicAdditionalContent isValue field="gender"/></td>
              <td>N <DemographicAdditionalContent isValue field="lunch"/></td>
              <td>Y <DemographicAdditionalContent isValue field="specialEducation"/></td>
              <td>YES <DemographicAdditionalContent isValue field="ell"/></td>
              <td>No <DemographicAdditionalContent isValue field="sld"/></td>
              <td></td>
              <td></td>
              <td>2022</td>
              <td>Sample School</td>
              <td>Sample Class</td>
              <td>Sample Teacher</td>
              <td>45</td>
              <td>Intensive Support</td>
              <td>48</td>
              <td>Core Support</td>
              <td>65</td>
              <td>Core Support</td>
              <td>19</td>
              <td>Core Support</td>
              <td>45</td>
              <td>Core Support</td>
              <td>66</td>
              <td>Core Support</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <p className="mb-1">
        In addition to matching the example format, please ensure your file does <b><u>not</u></b> contain any of the following:
      </p>
      <ul>
        <li>Duplicate Student IDs</li>
        <li>Blank Student IDs</li>
        <li>Student IDs containing characters other than letters and numbers</li>
        <li>Blank Student Names</li>
        <li>Student or Teacher Names containing characters other than letters, numbers, spaces, hyphen (-), apostrophe ('), and comma (,)</li>
        <li>More than one sheet in the workbook</li>
      </ul>
    </>
  );
};
export default DDMSExample;
